import React, { useContext } from 'react';
import { SiteThemeContext } from '../../contexts/SiteThemeProvider';
import AntSwitch from './AntSwitch';
const DarkModeSwitch = () => {
    const { handleThemeChange, theme } = useContext(SiteThemeContext);
    const themeClick = () => handleThemeChange();
    return React.createElement(AntSwitch, { color: "primary", onClick: themeClick, checked: theme === 'dark' });
};
export default DarkModeSwitch;
